export interface BatchDashboardStats {
  totalOpenBatches: number;
  batchesWithSingleItem: number;
  batchesNearDeadline: number;
  transmissionsToday: number;
  batchesManualProcessing?: number;
}

export interface BatchDashboardItem {
  id: string;
  batchNumber: number;
  estateId: string;
  insurerId: string;
  status: string;
  startDate: string;
  endDate: string;
  quotationCode: string;
  proposalCode: string | null;
  policyNumber: string | null;
  lastTransmittedAt?: string | null;
  nextTransmissionDate?: string | null;
  lastTransmittedCompetence?: string | null;
  createdAt: string;
  updatedAt: string;
  estate: {
    id: string;
    name: string;
    email: string;
  };
  insurer: {
    id: string;
    name: string;
    code: string;
  };
  itemCount: number;
  hasSingleItem: boolean;
  daysRemaining: number;
  dueDate: number | null;
  transmissionDate: string;
  isNearDeadline: boolean;
  isManualProcessing: boolean;
  lastErrorStep?: string | null;
  lastErrorMessage?: string | null;
  lastErrorAt?: string | null;
  firstErrorAt?: string | null;
  lastErrorRetryable?: boolean | null;
}

export const BatchStatusOptions = [
  { key: 'OPENED', value: 'OPENED', text: 'Aberto' },
  { key: 'PROCESSING', value: 'PROCESSING', text: 'Processando' },
  { key: 'AWAITING_POLICY_EMISSION', value: 'AWAITING_POLICY_EMISSION', text: 'Aguardando Emissão' },
  { key: 'ERROR', value: 'ERROR', text: 'Erro' },
  { key: 'PENDING', value: 'PENDING', text: 'Pendente' },
  { key: 'CLOSED', value: 'CLOSED', text: 'Fechado' },
  { key: 'CANCELLED', value: 'CANCELLED', text: 'Cancelado' },
];

export const translateBatchStatus = (status: string): string => {
  const statusMap: Record<string, string> = {
    OPENED: 'Aberto',
    PROCESSING: 'Processando',
    AWAITING_POLICY_EMISSION: 'Aguardando Emissão',
    ERROR: 'Erro',
    PENDING: 'Pendente',
    CLOSED: 'Fechado',
    CANCELLED: 'Cancelado',
    CANCELED: 'Cancelado',
  };
  return statusMap[status] || status;
};

export const getBatchStatusColor = (status: string): string => {
  const colorMap: Record<string, string> = {
    OPENED: 'blue',
    PROCESSING: 'yellow',
    AWAITING_POLICY_EMISSION: 'orange',
    ERROR: 'red',
    PENDING: 'yellow',
    CLOSED: 'grey',
    CANCELLED: 'red',
    CANCELED: 'red',
  };
  return colorMap[status] || 'grey';
};

/** Etapas do fechamento automático do lote na Yelum (ver BatchProcessingStep no backend). */
export const translateBatchErrorStep = (step: string): string => {
  const stepMap: Record<string, string> = {
    INITIAL: 'Início do processamento',
    REMOVING_EXPIRED: 'Remoção de apólices vencidas',
    CONSULTING_YELUM: 'Consulta à Yelum',
    CREATING_PROPOSAL: 'Criação de proposta',
    MOVING_BILLING: 'Movimentação de fatura',
    PROCESSING_DOCUMENTS: 'Processamento de documentos',
  };
  return stepMap[step] || step;
};


